<template>
    <div class="cont">
        <div v-if="!modalShowReg">
            <span v-if="!post_register">
                <form v-on:submit.prevent="checkEmail()">
                    <div class="form-group">
                        <div class=" shadow">
                            <input v-model="email" class="form-control" placeholder="Dirección de email"
                                   type="email" style="padding: 30px 30px" required>
                        </div>
                    </div>
                    <button type="submit" v-if="!this.stateButton"
                            class="btn btn-primary w-100"
                            style=" padding: 10px; color: #fff; border-radius: 4px; text-transform: uppercase; font-weight: 800; text-align: center; font-size: 1.5rem">
                        REGISTRATE AQUÍ
                    </button>
                    <button v-else=""
                            class="btn btn-default btn-round btn-block btn-lg"
                            style="color: #fff; border-radius: 4px; text-transform: uppercase; background-color: #2196F3;font-weight: 800; text-align: center;"
                            disabled>
                        <div class="row">&nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <half-circle-spinner
                                    :animation-duration="600"
                                    :size="15"
                                    color="#ffffff"
                            />&nbsp;&nbsp; Espere...
                        </div>
                    </button>
                </form>
            </span>
            <span v-else="">
                <div >
                    <span class="top_text">
                    <h3 style="line-height: 1">Te hemos enviado un email<br>Con toda la información</h3>
                    <span style="display: flex; flex-direction: row; justify-content: center">
                        <img src="../../../../public/image/resource/send_email.svg" width="200px"/>
                    </span>

                    </span>
                    <div>
                        <h2 style="font-size: 1.3rem; font-weight: 800; color: #3362CC">
                            Revisa tu bandeja de entrada y confirma tu registro al entrenamiento. Mira en las carpetas de SPAM, promociones, etc. por si hubiera llegado por error ahí y muévenos a tu bandeja principal si esto ha ocurrido</h2>
                    </div>
                </div>
            </span>
        </div>
        <div v-else="" class="top_text">
            <div style="font-size: 1rem; margin-top: 10px">
                No podemos encontrar tu dirección de email, por favor completa los datos para registrarte
            </div>
            <div class="text-center">
                <div class="card shadow" style="background-color: #5E72E4">
                    <div class="card-body">
                        <h4 class="">
                                    <span v-if="emailError">

                                        <div class="alert alert-danger" role="alert"
                                             style="animation: bounce 3s ease infinite">
                                         No hemos podido validar su dirección de email, por favor verifique e intente nuevamente
                                      </div>
                                    </span>
                    </h4>
                    <form v-on:submit.prevent="sendNewLeads()">
                        <div class="form-group">
                            <div class="input-group input-group-alternative">
                                <div class="input-group-prepend">
                                            <span class="input-group-text"><i
                                                    class="ni ni-user-run"></i></span>
                                </div>
                                <input v-model="name" class="form-control"
                                       placeholder="Tu nombre"
                                       type="text" style="padding: 30px 30px"
                                       required>
                            </div>
                        </div>
                        <div class="form-group ">
                            <div class="input-group input-group-alternative">
                                <div class="input-group-prepend">
                                            <span class="input-group-text"><i
                                                    class="ni ni-user-run"></i></span>
                                </div>
                                <input v-model="last_name" class="form-control"
                                       placeholder="Tu apellido"
                                       type="text" style="padding: 30px 30px"
                                       required>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-group input-group-alternative">
                                <div class="input-group-prepend">
                                            <span class="input-group-text"><i
                                                    class="ni ni-email-83"></i></span>
                                </div>
                                <input v-model="email" class="form-control" placeholder="Email address"
                                       style="padding: 30px 30px"
                                       type="email" required>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-group input-group-alternative">
                                <vue-phone-number-input v-model="movil"
                                                        :default-country-code="defaultCountry"

                                                        :translations="translations"
                                                        @update="onUpdate"
                                                        aria-required="true"
                                                        style="background-color: white; height: 40px">
                                </vue-phone-number-input>
                            </div>
                        </div>
                        <button type="submit" v-if="!this.stateButton"
                                class="btn btn-default btn-round btn-block btn-lg">Enviar
                        </button>
                        <button v-else=""
                                class="btn btn-default btn-round btn-block btn-lg" disabled>
                            <div class="row">&nbsp;&nbsp;
                                &nbsp;&nbsp;
                                <half-circle-spinner
                                        :animation-duration="600"
                                        :size="15"
                                        color="#ffffff"
                                />&nbsp;&nbsp; Espere...
                            </div>
                        </button>
                    </form>
                    <br>
                    <p class="text-center" style="color: white">Al hacer clic acepta nuestros terminos y condiciones</p>

                </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    import toastr from 'toastr'
    import {HalfCircleSpinner} from 'epic-spinners'
    import {FlowerSpinner} from 'epic-spinners'
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    export default {
        name: 'Form-landing',
        props:['data_landing'],
        components: {
            HalfCircleSpinner,
            VuePhoneNumberInput,
            FlowerSpinner
        },
        created() {

        },
        data() {
            return {
                bg_testi: '/image/resource/background_regalo-01.jpg',
                email: '',
                stateButton: '',
                modalShowReg: false,
                responseEmail: '',
                name: '',
                last_name: '',
                emailSend: false,
                emailError: false,
                post_register: false,
                comments: '',
                spiner: false,
                result:'',
                movil:'',
                defaultCountry: 'EC',
                countriesList: ['EC', 'VE', 'BR', 'AR', 'CL', 'COL', 'ES', 'PT', 'MX', 'CO', 'US', 'PE'],
                translations: {
                    countrySelectorLabel: 'Código',
                    countrySelectorError: 'Choisir un pays',
                    phoneNumberLabel: 'Numero de teléfono',
                    example: 'Exemple :'
                },
            }
        },
        computed: {
            ...mapState,
            ...mapGetters([])
        },
        methods: {
            checkEmail: function () {
                this.stateButton = true;
                localStorage.setItem('email', (this.email.trim()));
                localStorage.setItem('codeRelation', (this.data_landing.tag));
                var url_tk = '/oauth/token';
                axios.post(url_tk, {
                    grant_type: 'client_credentials',
                    client_secret: process.env.VUE_APP_CLIENT_AP,
                   client_id: process.env.VUE_APP_CLIENT_ID
                }).then(response => {

                    var url = '/api/client/addBook/check';
                    var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;

                    axios.post(url, {
                        headers: {
                            token
                        },
                        email: this.email.trim(),
                        proyect_id: process.env.VUE_APP_PROYECT_ID,
                        code_relation: this.data_landing.tag,
                        urlRoom:this.data_landing.urlRoom,
                        id_room:this.data_landing.id_room,
                        date:this.data_landing.date,
                        title: this.data_landing.title,
                        type:this.data_landing.type,
                        url_download: this.data_landing.url_download,
                    }).then(response => {

                        if (response.data === 0) {

                            this.modalShowReg = true;
                            this.stateButton = false;
                            this.$emit('close')
                        } else if (response.data === 1) {
                            toastr.info('Gracias por tu registro');
                            if(this.data_landing.type === '1'){
                                this.$router.push('/pro/descarga/gracias');
                            }else{
                                this.$router.push('/pro/master_class/gracias');
                            }
                            /*this.$emit('close');*/
                            this.post_register = true;
                            this.stateButton = false;
                            this.email = '';
                        }
                    });
                });
            },
            onUpdate(payload) {
                this.result = payload.formatInternational

            },

            sendNewLeads: function () {
                this.stateButton = true;
                var url_tk = '/oauth/token';
                axios.post(url_tk, {
                    grant_type: 'client_credentials',
                    client_secret: process.env.VUE_APP_CLIENT_AP,
                   client_id: process.env.VUE_APP_CLIENT_ID
                }).then(response => {

                    var url = '/api/v1/cambiando/addBook/event';
                    var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;

                    axios.post(url, {
                        headers: {
                            token
                        },
                        name: this.name,
                        last_name: this.last_name,
                        email: this.email,
                        magistral: true,
                        movil   : this.result,
                        proyect_id: process.env.VUE_APP_PROYECT_ID,
                        email_info: process.env.VUE_APP_EMAIL_INFO,
                        code_relation: this.data_landing.tag,
                        urlRoom:this.data_landing.urlRoom,
                        id_room:this.data_landing.id_room,
                        date:this.data_landing.date,
                        title: this.data_landing.title,
                        type:this.data_landing.type,
                        url_download: this.data_landing.url_download
                    }).then(response => {

                        if (response.data === 'noProcess') {
                            this.emailError = true;
                            this.stateButton = false;
                            toastr.error('por favor verifique su dirección de email e intente nuevamente');
                        } else {
                            this.stateButton = false;
                            this.modalShowReg = false;
                            this.emailSend = true;
                            this.email = '';
                            this.post_register = true;
                            /*this.$emit('close');*/
                            toastr.info('Gracias por tu registro, verifica tu buzón de email');
                            if(this.data_landing.type === '1'){
                                this.$router.push('/pro/descarga/gracias');
                            }else{
                                this.$router.push('/pro/master_class/gracias');
                            }

                        }
                    });
                });
            }
        }

    }
</script>
<style scoped>
    .top_text{

    }
    .cont {
        display: flex;
        flex-direction: row;

        justify-content: center;
        text-align: center;

    }
    .ancho{
        min-width: 400px;
    }
    input{
        width: 500px;
    }
    @media (max-width: 1000px) {
        .cont {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: center;
            text-align: center;
            padding-left: 0;
        }
        .top_text{
            margin-top: -30px
        }
        .ancho{
            width: 290px;
        }
        input{
            width: 350px;
        }
    }

</style>
